import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrEquipmentDroneType, SrEquipmentFuelType, SrEquipmentGet, SrEquipmentRefundType, SrEquipmentService } from '@app/services/sr-equipment.service';

@Component({
    selector: 'tt-sr-equipment',
    templateUrl: './sr-equipment.component.html',
    styleUrls: ['./sr-equipment.component.css'],
    standalone: false,
})
export class SrEquipmentComponent implements OnInit {
    public page?: SrEquipmentGet;
    public refundTypes: SrEquipmentRefundType[] = [];
    public fuelTypes: SrEquipmentFuelType[] = [];
    public droneTypes: SrEquipmentDroneType[] = [];
    public saving = false;
    public calculating = false;
    public error = '';

    constructor(private readonly equipment: SrEquipmentService, private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        const resourceId = String(this.navigator?.params['resource_id'] ?? '');
        try {
            await Promise.all([
                this.equipment.getEquipment({ resource_id: resourceId, srequipment_keyno: String(this.navigator?.params['srequipment_keyno'] ?? '') }).then(page => this.page = page),
                this.equipment.getRefundTypes({ resource_id: resourceId }).then(items => this.refundTypes = items),
                this.equipment.getFuelTypes().then(items => this.fuelTypes = items),
                this.equipment.getDroneTypes().then(items => this.droneTypes = items),
            ]);
        } catch (error) { this.error = error instanceof Error ? error.message : String(error); }
    }

    public async calculateRate(field: 'smallboat_rate' | 'drone_base_rate' | 'drone_rate'): Promise<void> {
        if (!this.page || this.calculating) return;
        this.calculating = true;
        try {
            const value: unknown = await this.modal.showCalculator(field, undefined, this.page[field]);
            if (typeof value === 'string' || typeof value === 'number') this.page[field] = value;
        } catch (error) { this.error = error instanceof Error ? error.message : String(error); }
        finally { this.calculating = false; }
    }

    public async save(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        this.error = '';
        try {
            const response = await this.equipment.saveEquipment(this.page);
            if (String(response.errorcode) !== '0') {
                await this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage,
                    buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
            } else await this.navigator?.back();
        } catch (error) { this.error = error instanceof Error ? error.message : String(error); }
        finally { this.saving = false; }
    }
}
